import { render, staticRenderFns } from "./AllGames.vue?vue&type=template&id=6519ffe6&scoped=true"
import script from "./AllGames.vue?vue&type=script&lang=js"
export * from "./AllGames.vue?vue&type=script&lang=js"
import style0 from "./AllGames.vue?vue&type=style&index=0&id=6519ffe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519ffe6",
  null
  
)

export default component.exports